import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import useUsersApi from '../../hooks/users/useUsersApi'

const ProfileImage = ({ user }) => {
  const [image, setImage] = useState(user.image)
  const [isImageError, setIsImageError] = useState(false)
  const inputRef = useRef()
  const classes = useStyles()
  const [_, { updateUser }] = useUsersApi()

  const initials = `${user.name.charAt(0)} ${user.surname.charAt(0)}`

  const handleImageError = () => {
    setIsImageError(true)
  }

  const handleSelectFile = (event) => {
    event.preventDefault()
    var files = event.target.files,
      f = files[0]
    var reader = new FileReader()
    reader.onload = (e) => {
      var data = e.target.result
      setImage(data)
      updateUser({ ...user, image: data }, null, true)
    }
    reader.readAsDataURL(f)
  }

  return (
    <div
      className={classes.userImageContainer}
      onClick={() => inputRef.current.click()}
    >
      {image && !isImageError ? (
        <img
          src={image}
          alt="guest"
          className={classes.image}
          onError={handleImageError}
        />
      ) : (
        <div className={classes.imagePlaceholder}>{initials}</div>
      )}
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={(event) => handleSelectFile(event)}
      />
    </div>
  )
}

export default ProfileImage

const useStyles = makeStyles(() => ({
  userImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    paddingLeft: '20px',
    paddingTop: '26px',
    cursor: 'pointer',
  },
  image: {
    borderRadius: '100%',
    height: '38px',
    minWidth: '38px',
    maxWidth: '38px',
    overflow: 'hidden',
    objectFit: 'cover',
  },
  imagePlaceholder: {
    borderRadius: '100%',
    height: '38px',
    minWidth: '38px',
    backgroundColor: 'white',
    color: '#3068f9',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontWeight: 400,
  },
}))
